import * as CONSTANTS from '@/constants';

export interface IInvoicesState {
	rightPanelCollapsed: boolean,
	offset: number,
	page: number,
	limit: number,
	status: Array<string>,
	documentType: Array<string>,
	dateRange: Array<any> | null,
	sort: object,
	searchTerm: string
}

const state: IInvoicesState = {
	rightPanelCollapsed: true,
	status: CONSTANTS.INVOICETABLE_DEFAULT_STATUS_LIST,
	documentType: CONSTANTS.INVOICETABLE_DEFAULT_TYPE_LIST,
	dateRange: null,
	sort: {},
	searchTerm: '',
	offset: 0,
	page: 1,
	limit: 25
};

const mutations = {
	SET_RIGHT_PANEL_COLLAPSED: (state, data) => {
		state.rightPanelCollapsed = data;
	},
	SET_STATUS: (state, data) => {
		state.status = data;
	},
	SET_DOCUMENT_TYPE: (state, data) => {
		state.documentType = data;
	},
	SET_DATE_RANGE: (state, data) => {
		state.dateRange = data;
	},
	SET_SORT: (state, data) => {
		state.sort = data;
	},
	SET_SEARCHTERM: (state, data) => {
		state.searchTerm = data;
	},
	SET_OFFSET: (state, data) => {
		state.offset = data;
	},
	SET_LIMIT: (state, data) => {
		state.limit = data;
	},
	SET_PAGE: (state, data) => {
		state.page = data;
	}
};

export default {
	namespaced: true,
	state,
	mutations
};
